import React from 'react';
import IonIcon from '@reacticons/ionicons';
import { TextInput, Popover, PopoverProps } from '@mantine/core';

type Props = PopoverProps & {
    searchValue: string;
    setSearchValue: (value: string) => void;
    children: React.ReactNode;
    open: boolean;
    setOpen: (value: boolean) => void;
    placeholder?: string;
    width?: number;
    dropdownWidth?: number;
    className?: string;
    transformX?: number;
};

export function SelectWithTable({ setSearchValue, open, setOpen, searchValue, children, position = "bottom", disabled, placeholder = "Search", width, dropdownWidth, className, transformX, ...props }: Props) {

    return (
        <Popover
            opened={open}
            onClose={() => setOpen(false)}
            withArrow
            withinPortal
            position={position}
            disabled={disabled}
            width={dropdownWidth ? `${dropdownWidth}px` : (width ? `${width}px` : undefined)}
            {...props}
        >
            <Popover.Target>
                <div
                    onClick={() => {
                        setOpen(true);
                    }}
                    style={{ width: width ? `${width}px` : '100%' }}
                    className={className}
                >
                    <TextInput
                        classNames={{
                            rightSection: "customSellectRightSection",
                            input: "customSelectInput",
                            wrapper: "newInputWrapper",
                        }}
                        disabled={disabled}
                        rightSection={<IonIcon style={{ width: "18px", height: "18px", top: "2px", left: "2px" }} color="black" name="search" />}
                        placeholder={placeholder}
                        value={searchValue}
                        onChange={(event) => setSearchValue(event.target.value)}
                        onFocus={() => setOpen(true)} // Open dropdown on focus
                        style={{ width: '100%' }}
                    />
                </div>
            </Popover.Target>
            <Popover.Dropdown
                style={{
                    width: dropdownWidth ? `${dropdownWidth}px` : (width ? `${width}px` : undefined),
                    minWidth: dropdownWidth ? `${dropdownWidth}px` : (width ? `${width}px` : undefined),
                    maxWidth: dropdownWidth ? `${dropdownWidth}px` : (width ? `${width}px` : undefined),
                    transform: transformX !== undefined
                        ? `translateX(${transformX}px)`
                        : undefined
                }}
            >
                {children}
            </Popover.Dropdown>
        </Popover>
    );
}
